<template>
    <v-container>
        <!-- 搜尋和操作區域 -->
        <v-row class="mb-6">
            <v-col cols="6">
                <v-text-field v-model="searchQuery" prepend-inner-icon="mdi-magnify" label="輸入分類名稱搜尋標籤名稱"
                    variant="outlined" density="comfortable" hide-details class="search-input"></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex justify-end" v-if="isEditing">
                <v-btn variant="flat" color="black" class="mr-2" dark @click="addNewTagCategory">
                    新增分類
                </v-btn>
                <v-btn variant="flat" color="black" class="mr-2" dark @click="deleteTagCategory"   >
                    刪除分類
                </v-btn>
                <v-btn variant="flat" color="black" dark @click="isEditing = false">
                    確定
                </v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-end" v-else>
                <v-btn variant="flat" color="black" class="mr-2" dark @click="isEditing = true">
                    編輯
                </v-btn>
            </v-col>
        </v-row>


        <!-- 標籤分類區域 -->
        <v-row>
            <v-col cols="12">
                <div v-for="(category, index) in filteredCategories" :key="index" class="category-section">

                    <div class="d-flex">
                        <v-checkbox v-if="isEditing" v-model="deleteTagCategoryDialog.selected" :value="category._id" hide-details class="tag-checkbox"></v-checkbox>
                        <span class="tag-title d-flex align-center">{{ category.tagCategoryTopic ? category.tagCategoryTopic.name : '無術式主題' }} - {{ category.name }}</span>
                    </div>


                    <v-divider class="my-4 tag-divider"></v-divider>

                    <div class="tag-group ml-4">
                        <div class="tags-wrapper">
                            <v-chip v-for="tag in category.tags" :key="tag.id"
                                :class="['tag-chip', { 'tag-selected': tag.selected }]" variant="outlined">
                                {{ tag.name }}
                                <v-icon v-if="isEditing" size="small" class="ml-2" @click.stop="deleteTag(tag._id)">mdi-minus</v-icon>
                            </v-chip>
                            <v-btn v-if="isEditing" variant="text"  class="add-tag-btn" small icon
                                @click="addNewTag(category._id)"><v-icon style="border: 1px solid #000; border-radius: 100%;">mdi-plus</v-icon></v-btn>
                        </div>
                    </div>

                </div>
            </v-col>
        </v-row>

        <!-- 新增標籤彈窗 -->
        <v-dialog v-model="addTagDialog.show" width="500">
            <v-card>
                <v-card-title>新增標籤</v-card-title>
                <v-card-subtitle>
                    <v-text-field class="ml-4 mr-4 mt-4" v-model="addTagDialog.tagName" label="標籤名稱" outlined>    
                    </v-text-field>
                </v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="flat" color="black" dark @click="addTagDialog.show = false">
                        取消
                    </v-btn>
                    <v-btn variant="flat" color="black" dark @click="confirmAddTag()">
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 新增標籤分類彈窗 -->
        <v-dialog v-model="addTagCategoryDialog.show" width="500">
            <v-card>
                <v-card-title>新增標籤分類</v-card-title>
                <v-card-subtitle>
                    <div class="d-flex align-center mt-4 mb-4">
                        <v-select 
                            v-model="addTagCategoryDialog.tagCategoryTopic" 
                            :items="tagCategoryTopics" 
                            item-text="name"
                            item-value="_id" 
                            label="術式主題" 
                            outlined
                            hide-details
                            class="flex-grow-1"
                            @change="logTagCategoryTopic"
                        ></v-select>
                        <v-btn 
                            icon 
                            variant="text" 
                            class="ml-2" 
                            @click="addNewTagCategoryTopic"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </div>
                    <v-text-field 
                        class="ml-4 mr-4 mt-4" 
                        v-model="addTagCategoryDialog.tagCategory" 
                        label="標籤分類名稱" 
                        outlined
                    ></v-text-field>
                </v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="flat" color="black" dark @click="addTagCategoryDialog.show = false">
                        取消
                    </v-btn>
                    <v-btn variant="flat" color="black" dark @click="confirmAddTagCategory()">
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 刪除標籤分類彈窗 -->
        <v-dialog v-model="deleteTagCategoryDialog.show" width="500">
            <v-card>
                <v-card-title>刪除標籤分類</v-card-title>
                <v-card-subtitle>確定要刪除嗎？</v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="flat" color="black" dark @click="deleteTagCategoryDialog.show = false">
                        取消
                    </v-btn>
                    <v-btn variant="flat" color="black" dark @click="confirmDeleteTagCategory()">
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 新增術式主題彈窗 -->
        <v-dialog v-model="addTagCategoryTopicDialog.show" width="500">
            <v-card>
                <v-card-title>新增術式主題</v-card-title>
                <v-card-subtitle>
                    <v-text-field 
                        class="ml-4 mr-4 mt-4" 
                        v-model="addTagCategoryTopicDialog.name" 
                        label="術式主題名稱" 
                        outlined
                    ></v-text-field>
                </v-card-subtitle>
                <v-card-actions>
                    <v-btn variant="flat" color="black" dark @click="addTagCategoryTopicDialog.show = false">
                        取消
                    </v-btn>
                    <v-btn variant="flat" color="black" dark @click="confirmAddTagCategoryTopic">
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 刪除術式主題彈窗 -->
        <v-dialog v-model="deleteTagCategoryTopicDialog.show" width="500">
            <v-card>
                <v-card-title>刪除術式主題</v-card-title>
                <v-card-subtitle>確定要刪除嗎？</v-card-subtitle>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="flat" color="black" dark @click="deleteTagCategoryTopicDialog.show = false">
                        取消
                    </v-btn>
                    <v-btn variant="flat" color="black" dark @click="confirmDeleteTagCategoryTopic">
                        確定
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import TagCategoryTopicService from '../../services/tagCategoryTopic.service.js';
import TagCategoryService from '../../services/tagCategory.service';
import TagService from '../../services/tag.service';
export default {
    name: 'TeacherCaseTags',
    data() {
        return {
            isEditing: false,
            searchQuery: '',
            addTagDialog: {
                show: false,
                tagName: '',
                tagCategory: '',
            },
            addTagCategoryDialog: {
                show: false,
                tagCategory: '',
                tagCategoryTopic: ''
            },
            deleteTagCategoryDialog: {
                show: false,
                tagCategory: '',
                selected: []
            },
            categories: [],
            addTagCategoryTopicDialog: {
                show: false,
                name: '',
                tagCategoryTopic: ''
            },
            deleteTagCategoryTopicDialog: {
                show: false,
                selected: []
            },
            tagCategoryTopics: [],
        }
    },
    mounted() {
        this.getTagCategoryBySchool();
        this.getTagCategoryTopicBySchool();
    },
    computed: {
        filteredCategories() {
            if (!this.searchQuery) {
                return this.categories;
            }

            const searchTerm = this.searchQuery.toLowerCase().trim();
            
            return this.categories.filter(category => {
                // 檢查分類名稱是否符合搜尋條件
                const categoryMatch = category.name.toLowerCase().includes(searchTerm);
                
                // 檢查該分類下的標籤是否符合搜尋條件
                const hasMatchingTags = category.tags.some(tag => 
                    tag.name.toLowerCase().includes(searchTerm)
                );
                
                // 如果分類名稱或任何標籤符合搜尋條件，就回傳該分類
                return categoryMatch || hasMatchingTags;
            }).map(category => ({
                ...category,
                // 只保留符合搜尋條件的標籤
                tags: category.tags.filter(tag =>
                    tag.name.toLowerCase().includes(searchTerm) ||
                    category.name.toLowerCase().includes(searchTerm)
                )
            }));
        }
    },
    methods: {
        toggleTag(categoryId, tag) {
            console.log(categoryId, tag)
            tag.selected = !tag.selected
        },
        addNewTag(categoryId) {
            console.log(categoryId)
            this.addTagDialog.show = true
            this.addTagDialog.categoryId = categoryId
        },
        addNewTagCategory() {
            this.addTagCategoryDialog.show = true
        },
        deleteTag(tagId) {
            TagService.delete(tagId).then(() => {
                this.getTagCategoryBySchool();
            });
        },
        deleteTagCategory() {
            this.deleteTagCategoryDialog.show = true
        },
        confirmDeleteTagCategory() {
            console.log(this.deleteTagCategoryDialog.selected)
            TagCategoryService.delete(this.deleteTagCategoryDialog.selected).then(() => {
                this.getTagCategoryBySchool();
                this.deleteTagCategoryDialog.show = false;
                this.deleteTagCategoryDialog.selected = []
            });
        },
        getTagCategoryBySchool() {
            TagCategoryService.getBySchool().then((response) => {
                this.categories = response.data;
            });
        },
        confirmAddTagCategory() {
            TagCategoryService.add({name: this.addTagCategoryDialog.tagCategory, tagCategoryTopic: this.addTagCategoryDialog.tagCategoryTopic}).then(() => {
                this.getTagCategoryBySchool();
                this.addTagCategoryDialog.show = false;
                this.addTagCategoryDialog.tagCategory = '';
                this.addTagCategoryDialog.tagCategoryTopic = '';
            });
        },
        confirmAddTag() {
            TagService.add({name: this.addTagDialog.tagName, category: this.addTagDialog.categoryId}).then(() => {
                this.getTagCategoryBySchool();
                this.addTagDialog.show = false;
                this.addTagDialog.tagName = '';
                this.addTagDialog.categoryId = '';
            });
        },
        getTagCategoryTopicBySchool() {
            TagCategoryTopicService.getBySchool().then((response) => {
                this.tagCategoryTopics = response.data.data;
            });
        },
        addNewTagCategoryTopic() {
            this.addTagCategoryTopicDialog.show = true;
        },
        deleteTagCategoryTopic() {
            this.deleteTagCategoryTopicDialog.show = true;
        },
        confirmAddTagCategoryTopic() {
            TagCategoryTopicService.add({
                name: this.addTagCategoryTopicDialog.name
            }).then(() => {
                this.getTagCategoryTopicBySchool();
                this.addTagCategoryTopicDialog.show = false;
                this.addTagCategoryTopicDialog.name = '';
            });
        },
        confirmDeleteTagCategoryTopic() {
            TagCategoryTopicService.delete(this.deleteTagCategoryTopicDialog.selected).then(() => {
                this.getTagCategoryTopicBySchool();
                this.deleteTagCategoryTopicDialog.show = false;
                this.deleteTagCategoryTopicDialog.selected = [];
            });
        },
        logTagCategoryTopic(value) {
            console.log(value)
            console.log(this.addTagCategoryDialog.tagCategoryTopic)
        }
    }
}
</script>

<style scoped>
.search-input {
    max-width: 400px;
}

.category-section {
    margin-bottom: 16px;
}

.tag-group {
    display: flex;
    align-items: center;
}

.tags-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
}

.tag-chip {
    cursor: pointer;
    padding: 0px 20px 0px 20px;
    height: 36px;
    border-radius: 10px;
}

.tag-divider {
    margin: 10px 12px !important;
}

.tag-selected {
    background-color: #E8F5E9;
    border-color: #4CAF50;
    color: #4CAF50;
}

.add-tag-btn {
    margin-left: 8px;
}

:deep(.v-chip) {
    font-size: 14px;
}

:deep(.v-checkbox .v-selection-control) {
    min-height: 32px;
}

.tag-title {
    font-size: 16px;
    text-align: left;
    font-weight: bold;
    color: #000;
}

.tag-checkbox {
    margin-right: 4px;
    margin-top: 0px;
}
</style>